import {CountryAlpha3CodeEnum} from './Countries';

export type BankListResponseBody = {
  code: string;
  name: string;
};
export type GetBankListApiResponse = /** status 200  */ BankListResponseBody[];

export type GetBankListApiArg = {
  countryCode?: CountryAlpha3CodeEnum;
};
